import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';
import '../fonts.css';
import API_BASE_URL from '../api';

const LocationInfo = () => {
  const [locationInfo, setLocationInfo] = useState({
    location: '',
    radius: '',
    willing_to_date_outside_range: '',
  });

  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/location-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No location info found. Please set your location info.');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch location info');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const locationData = data.reduce((acc, item) => {
            if (item.question_text === 'Where are you located?')
              acc.location = item.answer_text;
            if (
              item.question_text === 'What radius are you willing to date in?'
            )
              acc.radius = item.answer_int;
            if (
              item.question_text ===
              'Would you be willing to go on a date outside of this range?'
            ) {
              acc.willing_to_date_outside_range = item.answer_text; // Store the answer as text
            }
            return acc;
          }, {});
          setLocationInfo(locationData);
        }
      })
      .catch((error) => {
        console.error('Error fetching location info:', error);
        setMessage('Error fetching location info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    const payload = {
      location: locationInfo.location,
      radius: parseInt(locationInfo.radius, 10),
      willing_to_date_outside_range: locationInfo.willing_to_date_outside_range,
    };

    console.log('Submitting Location Info:', payload); // Log the payload being sent

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/location-info`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const textResponse = await response.text();
      console.log('Raw Response:', textResponse);

      if (!response.ok) {
        throw new Error('Failed to update location info');
      }

      setLocationInfo(payload); // Set state to the values that were just submitted
      setMessage('Location info updated successfully.');

      setTimeout(() => {
        navigate('/sex-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting location info:', error);
      setMessage('Failed to update location info.');
    }
  };

  const handleChange = (e) => {
    setLocationInfo({
      ...locationInfo,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1
            className="text-4xl font-bold text-white text-center mb-6"
            style={{ fontFamily: 'Inter', textTransform: 'uppercase' }}
          >
            Location Info
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                Where are you located?
                <input
                  type="text"
                  name="location"
                  value={locationInfo.location || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                  required
                />
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                What radius are you willing to date in? (miles/km)
                <input
                  type="number"
                  name="radius"
                  value={locationInfo.radius || ''}
                  onChange={handleChange}
                  className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                  required
                />
              </label>
            </div>
            <div className="text-white">
              <label className="block text-sm font-medium">
                Would you be willing to date outside this range?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="willing_to_date_outside_range"
                    value="No"
                    checked={
                      locationInfo.willing_to_date_outside_range === 'No'
                    }
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="willing_to_date_outside_range"
                    value="Maybe"
                    checked={
                      locationInfo.willing_to_date_outside_range === 'Maybe'
                    }
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Maybe</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="willing_to_date_outside_range"
                    value="Yes"
                    checked={
                      locationInfo.willing_to_date_outside_range === 'Yes'
                    }
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
              </div>
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/age-info')} // Navigate back to the previous form
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LocationInfo;
